import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6d9756be&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9756be')) {
      api.createRecord('6d9756be', component.options)
    } else {
      api.reload('6d9756be', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6d9756be&", function () {
      api.rerender('6d9756be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/calendar/src/main.vue"
export default component.exports